import { render, staticRenderFns } from "./FlagshipGoalsWizardRetirementFundSecond.vue?vue&type=template&id=fa0bc8b6&scoped=true&"
import script from "./FlagshipGoalsWizardRetirementFundSecond.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsWizardRetirementFundSecond.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipGoalsWizardRetirementFundSecond.vue?vue&type=style&index=0&id=fa0bc8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0bc8b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VRow,VTextField})
